import { onboardApi } from "./onBoardApi";
import { notapApi } from "./notapApi";
import { transfereeApi } from "./transfereeApi";
import { bankApi } from "./bankApi";
import { adminApi } from "./adminApi";
import { core_backend_url } from "../../config";

export const appApi = {
  currencies: `${core_backend_url}certificate/currencies`,
  searchCertificates: `${core_backend_url}certificate/search`,
  getHistory: (number) =>
    `${core_backend_url}certificate/transaction-history?certificate_no=${encodeURIComponent(
      number,
    )}`,
  getAdditionalDocuments: (certificate_id) =>
    `${core_backend_url}certificate/uploads/additional-documents/${certificate_id}`,
  getSingleCertificate: (certificate_id) =>
    `${core_backend_url}certificate/certificate/${certificate_id}`,
  getSingleLetter: (letter_id) =>
    `${core_backend_url}digital-letters/inbox/details/${letter_id}`,
  change_password: `${core_backend_url}user/change-password`,
  ...onboardApi,
  getBanks: `${core_backend_url}auth/banks`,
  ...transfereeApi,
  ...bankApi,
  ...notapApi,
  ...adminApi,
};
